/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./digitalTwinList.vue?vue&type=template&id=6f2d6988&scoped=true&"
import script from "./digitalTwinList.vue?vue&type=script&lang=js&"
export * from "./digitalTwinList.vue?vue&type=script&lang=js&"
import style0 from "./digitalTwinList.vue?vue&type=style&index=0&id=6f2d6988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2d6988",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VDataTable,VDialog,VIcon,VRow,VTreeview})
